import React, { useEffect, Suspense, lazy, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { AutoLogin, SilentLogin, logout } from "../AppRedux/Actions/Auth";
import './global.css';
import Loader from "./loader";
import { ToastContainer, Slide } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { showError } from "../AppRedux/Actions";

const Login = lazy(() => import("../Pages/Auth/LoginPage"));
const TarangLogin = lazy(() => import("../Pages/Auth/LoginPageTarang"));
const ForgotPasswordPage = lazy(() => import("../Pages/Auth/ForgotPasswordPage"));
const ResetPassowrdPage = lazy(() => import("../Pages/Auth/ResetPassowrdPage"));
const SSOLoginPage = lazy(() => import("../Pages/Auth/SSOLoginPage"));
// const RegisterPage = lazy(() => import("../Pages/Auth/RegisterPage"));
const MainApp = lazy(() => import("../Components"));

const checkVersionChange = (next) => {
    (async (next) => {
        try {
            const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
            if (buildNumber && buildNumber !== localStorage.getItem('app_build_number')) {
                localStorage.setItem('app_build_number', buildNumber);
                if ('caches' in window) {
                    const { caches } = window;
                    const cache = await caches.keys();
                    await Promise.all(cache.map((key) => caches.delete(key)));
                }
                if ('serviceWorker' in navigator) {
                    const registrations = await navigator.serviceWorker.getRegistrations();
                    registrations.forEach((registration) => { registration.unregister(); });
                }
                next();
            } else {
                next();
            }
        } catch (err) {
            next();
        }
    })(next);
}

const RestrictedRoute = ({ component: Component, token, ...rest }) => (
    <Route {...rest} render={props => <Component {...props} />} />);

function getFirstUrl(firtMenu) {
    const { children = [], url, menu_version } = firtMenu ?? {};
    if (children.length > 0 && menu_version === 1) {
        for (let target = 0; target < children.length; target++) {
            return getFirstUrl(children[target]);
        }
    }
    return url;
}

const saveDomainRedirectCount = (dispatch, history, redirect_url, save_count = true, call_back = () => { }) => {
    return call_back();
    redirect_url = redirect_url || window.location.href;
    if (redirect_url && (redirect_url?.includes('zimyo') || redirect_url?.includes('localhost'))) {
        const time_out_id = Date.now(), wait_time = 30000; // in milliseconds
        let countObj = localStorage.getItem('redirect_count');
        countObj = typeof countObj === 'string' ? JSON.parse(countObj) : countObj;
        countObj = typeof countObj === 'object' ? countObj || {} : {};
        countObj[redirect_url] = (Number(countObj[redirect_url] || 0) || 0);
        if (!countObj['time_out_id']) {
            countObj['time_out_id'] = time_out_id;
        }
        if (time_out_id - countObj['time_out_id'] > wait_time) {
            countObj['time_out_id'] = time_out_id;
            countObj[redirect_url] = 0;
        }
        countObj[redirect_url] += 1;
        if (countObj[redirect_url] > 3) {
            dispatch(logout(history));
            showError(dispatch, 'Too many login attempts. Please wait and try again.');
        } else {
            typeof call_back == 'function' && call_back();
        }
        save_count && localStorage.setItem('redirect_count', JSON.stringify(countObj));
    } else {
        typeof call_back == 'function' && call_back();
    }
}

const getCookie = (name = 's_token') => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

const setCookie = (token = '', domain = 'zimyo.work', app_host = '') => {
    app_host = new URL(app_host).origin;
    if (window.location.origin !== app_host) {
        document.cookie = `s_token=${token}; path=/; domain=.${domain}; Secure; SameSite=None`;
        window.open(`${app_host}/login`, '_self');
        return true;
    }
    return false;
}

const deleteCookie = (name, domain = window.location.hostname) => {
    document.cookie = `${name}=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=None`;
}

const Theame = (props) => {
    const dispatch = useDispatch();
    const { history, location, match } = props;
    const { authUser, initURL, screenSetting, menus, user } = useSelector(state => state.auth);
    const [isTokenVerifed, setTokenVerifed] = useState(false);
    const redirectCountRef = React.useRef(0);

    // Create an instance of URLSearchParams to extract the query params
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        checkVersionChange(() => {
            const cookie_token = getCookie('s_token');
            deleteCookie('s_token', '.zimyo.work');
            if (process.env.REACT_APP_VALIDATE_DOMAIN === 'true' && cookie_token) {
                console.log('cookie login.......');
                dispatch(AutoLogin(cookie_token, setTokenVerifed));
            } else
                if (authUser) {
                    dispatch(AutoLogin(authUser, setTokenVerifed));
                } else {
                    dispatch(SilentLogin(location, history));
                }
        });
    }, [dispatch, history, authUser]);

    useEffect(() => {
        if (authUser && isTokenVerifed) {
            if (location.pathname === "/" && !(initURL === "" || initURL === "/" || initURL === "/login")) {
                history.replace(initURL);
            } else {
                // Get the specific 'redirect' parameter
                const redirectUrl = queryParams.get('app_slug') || queryParams.get('redirect') || queryParams.get('app_callback_url');
                saveDomainRedirectCount(dispatch, history, redirectUrl, true, () => {
                    /* getting valid domains and validating is given domain is includes on of */
                    if (redirectUrl?.includes('localhost')) {
                        window.location.href = redirectUrl + location.search + `&token=${authUser}`;
                    } else {
                        const originPath = window.location.origin;
                        const isLocalhostOrigin = originPath?.includes('localhost');
                        // checking for is user admin or not
                        const isAdmin = (user?.role_ids?.includes(2) || user?.role_ids?.includes(8) || user?.role_ids?.includes('-2'));
                        // checking for the domain 
                        if (process.env.REACT_APP_VALIDATE_DOMAIN === 'true' && !isLocalhostOrigin && user.user_app_access_list.length > 0 && setCookie(authUser, 'zimyo.work', user.user_app_access_list[0].link)) {
                            return;
                        }

                        const redirectApp = user?.user_app_access_list?.find((item) => item.app_slug == redirectUrl) || user?.user_app_access_list[0];
                        if (redirectApp?.link) {
                            let redirectLink = isLocalhostOrigin ? redirectApp.link : `${originPath}/${redirectApp.app_slug}`;
                            if (!menus.length && isAdmin) {
                                history.replace(initURL + location.search);
                            } else {
                                // const isSubscriptionExpired = user?.role_ids?.some((item) => item == -2)
                                const openManage = queryParams.get('isOpenModal');
                                if (openManage != 'true') {
                                    window.open(redirectLink += location.search || '', '_self');
                                }
                                // else if (!isSubscriptionExpired) {
                                //     window.open(redirectLink, '_self');
                                // }
                            }
                        } else {
                            const isSubscriptionExpired = user?.role_ids?.some((item) => item == -2)
                            if (isSubscriptionExpired) {
                                history.replace(`${initURL}?isOpenModal=true&block=true`);
                            }
                            else history.replace("/login");
                        }
                    }
                });
            }
        }
    }, [dispatch, authUser, initURL, history, menus, isTokenVerifed, location.pathname]);

    if (screenSetting) {
        return <Loader />
    }

    const publicRoutes = [
        { path: '/login', compnent: (window.location.origin.includes('tarangneu.zimyo.work') || window.location.origin.includes('newadmin.zimyo.net')) ? TarangLogin : Login },
        { path: '/forgot-password', compnent: ForgotPasswordPage },
        { path: '/reset-password', compnent: ResetPassowrdPage },
        { path: '/auth/login-sso', compnent: SSOLoginPage },
        // { path: '/register', compnent: RegisterPage },
    ]

    return (
        <>
            <Loader />
            <Suspense fallback={<Loader />}>
                <ToastContainer limit={5} pauseOnHover={false} autoClose={5000} closeButton={true} hideProgressBar={false} transition={Slide} draggable={false} icon={true} />
                <Switch>
                    {
                        publicRoutes.map((item, index) => <Route key={index} exact path={item.path} component={item.compnent} />)
                    }
                    <RestrictedRoute path={`${match.url}`} token={authUser} component={MainApp} />
                </Switch>
            </Suspense>
        </>
    );
}

export default Theame;
